import React from 'react';
import './style.css';

const GoogleButton = ({ text, onClick, disabled }) => (
  <div className="google-button d-flex align-items-center">
    <div className="google-button-icon d-flex align-items-center justify-content-center border-right-0">
      <img src="/assets/google.png" alt="google" />
    </div>
    <button
      type="button"
      className="btn btn-primary btn-lg btn-cursor w-100"
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  </div>
);

export default GoogleButton;



// WEBPACK FOOTER //
// ./src/components/GoogleButton/index.js